import { LocationClient, SearchPlaceIndexForTextCommand } from "@aws-sdk/client-location";
import { fetchAuthSession } from "aws-amplify/auth";

// env
const {
  REACT_APP_REGION,
  REACT_APP_PLACE_INDEX_NAME,
} = process.env;

// Normalize state names — Places API returns English/variant names
const STATE_ALIASES = {
  'Penang': 'Pulau Pinang',
  'Malacca': 'Melaka',
  'Trengganu': 'Terengganu',
  'KL': 'Kuala Lumpur',
  'W.P. Kuala Lumpur': 'Kuala Lumpur',
  'Wilayah Persekutuan Kuala Lumpur': 'Kuala Lumpur',
  'Federal Territory of Kuala Lumpur': 'Kuala Lumpur',
  'W.P. Putrajaya': 'Putrajaya',
  'Wilayah Persekutuan Putrajaya': 'Putrajaya',
  'Federal Territory of Putrajaya': 'Putrajaya',
  'W.P. Labuan': 'Labuan',
  'Wilayah Persekutuan Labuan': 'Labuan',
  'Federal Territory of Labuan': 'Labuan',
};

const normalizeState = (state) => STATE_ALIASES[state] || state;

export const searchLocation = async (query) => {
  const { credentials } = await fetchAuthSession();

  const client = new LocationClient({
    region: REACT_APP_REGION,
    credentials,
  });

  const command = new SearchPlaceIndexForTextCommand({
    IndexName: REACT_APP_PLACE_INDEX_NAME,
    Text: query,
    FilterCountries: ['MYS'],
    MaxResults: 5,
    Language: 'ms',
  });

  const response = await client.send(command);

  const results = (response.Results || []).map((result) => {
    const place = result.Place;
    return {
      country: 'MYS',
      country_code: 'MYS',
      state: normalizeState(place.Region || ''),
      municipality: place.Municipality || place.SubRegion || '',
      // postal_code: place.PostalCode || '',
      label: place.Label || '',
      geometry: place.Geometry?.Point || null,
    };
  });

  return results;
};